import { TmcContextService } from './../../../../common/tmc-context.service';
import { TransportNote } from './../../model/transport-note';
import { TransportDetailsService } from '../../../../components/transport-details-legacy/service/transport-details.service';
import { TranslationService } from '@sdbn/common';
import { RoutingPositionLog } from './../../model/routing-position';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { AccountInfoService } from '@sdbn/common';
import { Clipboard } from '@angular/cdk/clipboard';
import { WidgetStyle } from '@sdbn/common';

@Component({
  selector: 'app-transport-log',
  templateUrl: './transport-log.component.html',
  styleUrls: ['./transport-log.component.scss']
})
export class TransportLogComponent extends AbstractWidgetComponent implements AfterViewInit {

  showLogEntryKeys = false;
  showLogEntryKeysSelectionKey = 'app-transport-log.showLogEntryKeys.';

  allowLogEntryKeySelection = false;

  detailsForm = new FormGroup({});

  componentSizeStyle = 'middle-size';

  routingPositions = new Array<RoutingPositionLog>();
  transportId: number;

  noteModel = '';

  loading = false;

  @ViewChild('rootNode')
  rootNode: ElementRef;

  constructor(
    private snackBar: MatSnackBar,
    private componentSelectionStorageService: ComponentSelectionStorageService,
    public translationService: TranslationService,
    private transportDetailsService: TransportDetailsService,
    private tmcContextService: TmcContextService,
    accountInfoService: AccountInfoService,
    private clipboard: Clipboard) {

    super();

    if (accountInfoService.checkPrivilegeExistsForYardKey(this.tmcContextService.getYardKey(), 'tmc-yard.inspect-transport-log')) {

      this.allowLogEntryKeySelection = true;

    } else {

      this.allowLogEntryKeySelection = false;
      this.showLogEntryKeys = false;

    }

    this.detailsForm.addControl('showLogEntryKeys', new FormControl(false, []));
    this.detailsForm.valueChanges.subscribe(
      () => {
        this.showLogEntryKeys = this.detailsForm.controls.showLogEntryKeys.value;
        this.componentSelectionStorageService.save(this.showLogEntryKeysSelectionKey + this.widgetIdentifier, this.showLogEntryKeys);
      }
    );
  }
  ngAfterViewInit(): void {
    this.identifySize(this.rootNode.nativeElement.offsetWidth);
  }

  private identifySize(width: number) {
    if (width <= 400) {
      this.componentSizeStyle = 'small-size';
    } else if (width <= 700) {
      this.componentSizeStyle = 'middle-size';
    } else {
      this.componentSizeStyle = 'large-size';
    }
  }

  onContextChange(contextChange: ContextChange) {

    if (contextChange.key === 'selected-transport') {

      const selectedTransport = this.dashboardContext.context.get('selected-transport');
      if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
        this.transportId = selectedTransport.id;
        this.loadTransportLog();
      }
    }

    if (contextChange.key === 'transport-changed') {
      if (this.transportId != null) {
        this.loadTransportLog();
      }
    }
  }

  onSetElementAndContext() {
    if (this.dashboardContext.context.get('selected-transport') != null) {
      this.transportId = this.dashboardContext.context.get('selected-transport').id;
      this.loadTransportLog();
    }

    this.showLogEntryKeys = this.allowLogEntryKeySelection && this.componentSelectionStorageService.get(this.showLogEntryKeysSelectionKey + this.widgetIdentifier);
    this.detailsForm.reset({ showLogEntryKeys: this.showLogEntryKeys });
  }

  private loadTransportLog() {
    this.transportDetailsService.getRoutingPositionLogs({ id: this.transportId }).subscribe(
      logs => {
        this.routingPositions = logs;
        for (const rp of this.routingPositions) {
          for (const e of rp.LogEntryViews) {
            if (e.logActivityType != null) {
              const logActivityTypeTranslated = this.translationService.translate('tmc-yard.ui.transport.details.dialog.routingActivityType.' + e.logActivityType)
              if (logActivityTypeTranslated != null && logActivityTypeTranslated.length > 0) {
                e.logActivityTypeTranslated = logActivityTypeTranslated;
              }
            }
          }
          console.log('loadTransportLog', logs);
        }
      }
    );
  }

  addNote() {

    this.loading = true;

    const transportNote = new TransportNote();
    transportNote.transportId = this.transportId;
    transportNote.note = this.noteModel;

    this.transportDetailsService.addNote(transportNote).subscribe(result => {
      // wird die Komponente als widget ausgeführt, muss sie sich selbst aktualisieren
      if (this.dashboardContext != null) {
        this.loadTransportLog();
      }

      this.noteModel = '';
      this.loading = false;
    }, error => {
      console.log(error);
      this.loading = false;
    });
  }

  public copyLogKeyToClipboard(hashKey: string) {
    navigator.clipboard.writeText(hashKey);

    this.snackBar.open(this.translationService.translate('tmc-yard.ui.transport.details.dialog.protocol.copied-to-clipboard'), null, {
      duration: 3000
    });
  }

  private makeString(value: string, length: number): string {
    let result = value != null ? value : '';
    while (result.length < length) {
      result += ' ';
    }
    return result;
  }

  public copyLogToClipboard() {

    let string = 'Transport Log - Transport ' + this.transportId + '\n';

    for (let position of this.routingPositions) {

      string += '\n-------------------------------\n\n';

      if (position.stationName != null) {
        string += this.translationService.translate('tmc-yard.ui.transport.details.dialog.stationName') + ": " + position.stationName + '\n';
      }
      string += ' ';
      if (position.cargo != null) {
        string += this.translationService.translate('tmc-yard.ui.transport.details.dialog.cargo') + ": " + position.cargo + '\n';
      }
      string += ' ';
      if (position.positionStatus != null) {
        string += this.translationService.translate('tmc-yard.ui.transport.details.dialog.positionStatus') + ": " + this.translationService.translate('tmc-yard.ui.transport.details.dialog.positionStatus.' + position.positionStatus) + '\n';
      }
      string += ' ';
      if (position.actionType != null) {
        string += this.translationService.translate('tmc-yard.ui.transport.details.dialog.actionType') + ": " + this.translationService.translate('tmc-yard.ui.transport.details.dialog.actionType.' + position.actionType) + '\n';
      }

      string += '\n';

      for (let entry of position.LogEntryViews) {

        if (entry.executionType != null) {
          string += entry.executionType;
        }
        string += '   ';
        if (entry.timestamp != null) {
          string += entry.timestamp;
        }
        string += '   ';
        if (entry.logActivityTypeTranslated != null && entry.logActivityTypeTranslated.length > 0) {
          string += this.makeString(entry.logActivityTypeTranslated, 30);
          string += ' ';
        }

        if (entry.text != null) {
          string += entry.text;
        }

        string += '\n';
      }

    }

    this.clipboard.copy(string);

    this.snackBar.open(this.translationService.translate('tmc-yard.ui.transport.details.dialog.protocol.copied-to-clipboard'), null, {
      duration: 3000
    });
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
